import { Flex, Separator, SimpleGrid, Text } from "@chakra-ui/react";
import TableList from "components/TableList";
import useCheckMobileScreen from "hooks/useCheckMobileScreen";
import { useLocation, useNavigate } from "react-router-dom";
import { ToggleSwitch } from "components/ToggleSwitch";
import { useEffect, useState } from "react";
import { Header } from "components/Header";
import InputComp from "components/InputComp";
import { toaster } from "components/ui/toaster";
import { api } from "services/api";
import Layout from "components/Layout";
import ButtonComp from "components/Button";
import utils from "utils";

const width1 = "7.5rem";

const fs = "sm";

const headers = [
  "Number",
  "Qty",
  {
    label: "Price",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "Description",
];
const headersLab = [
  //  "Serial",
  "Qty",
  {
    label: "Price",
    colW: "12ch",
    style: {
      textAlign: "end",
    },
  },
  "Description",
];

// const validaePartItm = ({ partnum }) => {
//   let errMsg = "";
//   if (partnum === undefined || partnum === null || partnum === "") {
//     errMsg = "please enter part number";
//   }
//   return errMsg;
// };

const validaeLabItm = ({ labAmt }) => {
  let errMsg = "";
  if (labAmt === undefined || labAmt === null || labAmt === "") {
    errMsg = "please enter labour price";
  }
  return errMsg;
};

const ClaimViewStepParts = () => {
  const [isLoading, setIsLoading] = useState(false);
  // part
  const [partlist, setPartList] = useState([]);
  const [selectedItemPl, setSelectedItemPl] = useState();
  const [partnum, setPartNum] = useState();
  const [partQt, setPartQt] = useState();
  const [partAmt, setPartAmt] = useState();
  const [partDesc, setpartDesc] = useState();
  // labour
  const [lablist, setLabList] = useState([]);
  const [selectedItemLab, setSelectedItemLab] = useState();
  const [labQt, setLabQt] = useState();
  const [labAmt, setLabAmt] = useState();
  const [labDesc, setLabDesc] = useState();

  const [adjustedclaim, setAdjustedclaim] = useState();
  const [calculatedtotal, setCalculatedtotal] = useState();
  const [calculatedtotal2, setCalculatedtotal2] = useState();
  const [claimnumber, setClaimnumber] = useState();
  const [claimtotal, setClaimtotal] = useState();
  const [labourtotal, setLabourtotal] = useState();
  const [partstotal, setPartstotal] = useState();
  const [payvat, setPayvat] = useState();
  const [claimvatamt, setClaimvatamt] = useState();
  const [state, setState] = useState();

  const [claimStatusDD, setClaimStatusDD] = useState([]);
  const [settingvat, setSettingvat] = useState(0);
  const [r1, setR1] = useState(0);

  const navigate = useNavigate();
  const ismobile = useCheckMobileScreen();
  const location = useLocation();
  const itemData = location.state?.data?.itemData;
  const navState = location.state;

  const genPayl = () => {
    const pl = {
      ...itemData,
      state: state, // 25
      // mileageatclaim: mileageatclaim || "",
      failedpart: "",
      failedarea: "",
      // failurecause: failurecause || "",
      // repairsrequired: repairsrequired || "", // 5
      labourperhour: 0,
      partstotal: partstotal || 0,
      labourtotal: labourtotal || 0,
      calculatedtotal: calculatedtotal2 || claimtotal || 0,
      claimvatamt: claimvatamt || 0, //10
      claimtotal: claimtotal || 0,
      payvat: payvat ? true : false,
      adjustedclaim: adjustedclaim || 0,
      // policyid: policyid,

      // lastservicedates: lastservicedates || "", //15
      // faultdiagnosed: faultdiagnosed || false,
      // confirmedwarrantyclaim: confirmedwarrantyclaim || false,
      // advicedtodiagnosefault: advicedtodiagnosefault || false,
      // advicedtosenddiagnostic: advicedtosenddiagnostic || false,
      // hasbooklet: hasbooklet || false, // 20
      // repairinggarage: repairinggarage || "",
      // dateclaim: utils.dateToDateInput(),
      // claimdateseconds: utils.yyyymmddToDbSec(new Date()),
      // state: stateid, // 25
      // notes: notes || "",
      claimsvatcent: 0,
      // claimnotifyemail: claimnotifyemail || "",
    };

    // newclaimnum =  '';
    pl.claimsparts_data = [];
    pl.claimslabour_data = [];

    if (partlist && partlist[0]) {
      pl.claimsparts_data = partlist.map((a) => {
        return a?.data;
        // {
        //   partnumber: a?.data?.partnumber,
        //   qty: a?.data?.qty,
        //   partprice: a?.data?.partprice,
        //   claimid: a?.data?.claimid,
        //   claimnumber: a?.data?.claimnumber,
        //   partdesc: a?.data?.partdesc,
        // };
      });
    }

    if (lablist && lablist[0]) {
      pl.claimslabour_data = lablist.map((a) => {
        return a.data;
        // {
        //   labourqty: a?.data?.labourqty || 0,
        //   labourprice: a?.data?.labourprice || 0,
        //   labourdesc: a?.data?.labourdesc || 0,
        //   claimid: 0,
        //   claimnumber: a?.data?.claimnumber || 0,
        //   newclaimnum: 0,
        // };
      });
    }
    return pl;
  };

  const getVat = () => {
    setIsLoading(true);

    api.getVat().then((res) => {
      console.log(res);
      setIsLoading(false);

      if (res?.status === 200) {
        if (res?.data?.settingtype === "VAT") {
          setSettingvat(
            parseFloat(parseFloat(res?.data?.settingvalue || 0).toFixed(2), 10)
          );
        }
      } else {
        setSettingvat(0);

        toaster.create({
          title: res?.message,
          type: "error",
        });
      }
    });
  };

  const onSave = async () => {
    const pl = genPayl();
    let errMsg = "";

    if (!errMsg && !state) {
      errMsg = "please select state";
    }

    if (errMsg) {
      toaster.create({
        title: errMsg,
        type: "error",
      });
      return;
    }

    if (itemData.claimid || navState.action === "claim-edit") {
      setIsLoading(true);
      const res = await api.updateClaim(pl);
      console.log("onSave", res);
      setIsLoading(false);
      if (res?.status === 200) {
        toaster.create({
          title: res?.data?.message || res?.message,
          type: "success",
        });

        navigate("/claims", {
          state: {},
        });
      } else {
        toaster.create({
          title: res?.message,
          type: "error",
        });
      }

      return;
    }
    setIsLoading(true);
    const res = await api.addClaim(pl);
    console.log("onSave", res);
    setIsLoading(false);
    if (res?.status === 200) {
      toaster.create({
        title: res?.data?.message || res?.message,
        type: "success",
      });

      navigate("/claims", {
        state: {},
      });
    } else {
      toaster.create({
        title: res?.message,
        type: "error",
      });
    }
  };

  const onPrev = () => {
    const v = genPayl();
    // setPayl(pl);
    // setStatus("");
    // navigate(-1);

    let action2 = "claim-add";
    if (navState?.action === "claimviewstepparts-edit") {
      action2 = "claim-edit";
    }

    navigate("/ClaimView", {
      state: {
        action: action2,
        data: { itemData: v },
      },
    });
  };

  const onChangeSwVat = (v) => {
    setPayvat(v);
    // if (v === true) {
    //   setClaimvatamt();
    // } else {
    //   setClaimvatamt();

    // }
  };

  const onChangeClaimStDD = async (data) => {
    console.log("onChangeClaimStDD", {
      itemData,
      data,
    });

    setClaimStatusDD(data?.list ? [...data?.list] : []);

    const stateidd = data?.item?.data?.stateid;
    setState(stateidd);
  };

  // parts
  const onUpdatePartList = ({ action }) => {
    // if (action === "add" || action === "update") {
    //   let errMsg = validaePartItm({ partnum });
    //   if (errMsg) {
    //     toaster.create({
    //       title: errMsg,
    //       type: "error",
    //     });
    //     return;
    //   }
    // }

    // check part number is already inlist ,
    //  if not add new otherview update

    let newlist = [...partlist];

    if (action === "del") {
      newlist = newlist.filter(
        (a) => selectedItemPl?.item?.data?.id !== a?.data?.id
      );
      // setSelectedItemLab();
    }
    console.log("selectedItemPl", selectedItemPl?.item);

    const newItem = {
      id: selectedItemPl?.item?.data?.partid,
      // key: `partlist-${partlist?.length}`,
      number: partnum,
      qt: partQt,
      amt: utils.formatAmountForTb(partAmt || 0),
      desc: partDesc,
      data: {
        id: selectedItemPl?.item?.data?.partid,
        amt: partAmt,
        // qty: partQt,
        desc: partDesc,

        partid: selectedItemPl?.item?.data?.partid,
        partnumber: partnum,
        qty: partQt,
        partprice: partAmt,
        claimid: 0,
        claimnumber: "",
        partdesc: partDesc,
      },
    };

    if (action === "add") {
      const newid = -utils.dateToEpoch(new Date());
      newItem.id = newid;
      newItem.data.id = newid;
      newItem.data.partid = newid;

      // if (partnum)
      // const already = newlist.filter((a) => newItem.data?.id === a?.data?.id);
      // console.log(" already", already);

      // if (already && already[0]?.data?.id) {
      //   toaster.create({
      //     title: "partnumber id is already in list",
      //     type: "error",
      //   });
      // } else {
      newlist.push(newItem);
      // }
    }

    if (action === "update") {
      newlist = newlist.map((a) => {
        if (selectedItemPl?.item?.data?.id === a?.data?.id) {
          return newItem;
        } else {
          return a;
        }
      });
    }

    setPartList(newlist);
  };

  const onAddPart = () => {
    onUpdatePartList({ action: "add" });
  };

  const onDelPart = () => {
    onUpdatePartList({ action: "del" });
  };

  const onSavePart = () => {
    onUpdatePartList({ action: "update" });
  };

  const onSelectItmPl = (data) => {
    console.log("onSelectItmPl", data);
    setSelectedItemPl(data);
    // if (data?.item?.data?.id) {

    setPartNum(data?.item?.data?.partnumber || "");
    setPartQt(data?.item?.data?.qty || "");
    setPartAmt(data?.item?.data?.partprice || "");
    setpartDesc(data?.item?.data?.partdesc || "");

    // utils.getCliamStatusDD({
    //   setClaimStatusDD,
    //   defaultVal: data?.item?.data?.state,
    // });
    // }
  };

  // labour
  const onUpdateLabList = ({ action }) => {
    if (action === "add" || action === "update") {
      let errMsg = validaeLabItm({ labAmt });
      if (errMsg) {
        toaster.create({
          title: errMsg,
          type: "error",
        });
        return;
      }
    }

    // check part number is already inlist ,
    //  if not add new otherview update

    let newList = [...lablist];

    if (action === "del") {
      newList = newList.filter(
        (a) => selectedItemLab?.item?.data?.id !== a?.data?.id
      );
      // setSelectedItemLab();
    }

    let idd = 1; // lablist?.length ? lablist?.length + 1 : 1;
    if (lablist && lablist[0]?.data?.id) {
      idd = lablist[lablist.length - 1]?.data?.id + 1;
    }
    const newItem = {
      id: idd,
      // key: `Lablist-${partlist?.length}`,
      // number: idd,
      qt: labQt,
      amt: utils.formatAmountForTb(labAmt || 0),
      desc: labDesc,
      data: {
        id: idd,
        amt: labAmt,

        labourid: idd,
        labourqty: labQt || 0,
        labourprice: labAmt || 0,
        labourdesc: labDesc || "",
        claimid: 0,
        claimnumber: 0,
        newclaimnum: 0,
      },
    };

    if (action === "add") {
      newList.push(newItem);
    }

    if (action === "update") {
      newList = newList.map((a) => {
        if (selectedItemLab?.item?.data?.id === a?.data?.id) {
          newItem.data.id = a?.data?.id;
          newItem.id = a?.data?.id;
          //newItem.number = a?.data?.id;

          return newItem;
        } else {
          return a;
        }
      });
    }

    setLabList(newList);
  };

  const onAddLab = () => {
    onUpdateLabList({ action: "add" });
  };

  const onDelLab = () => {
    onUpdateLabList({ action: "del" });
  };

  const onSaveLab = () => {
    onUpdateLabList({ action: "update" });
  };

  const onSelectItmLab = (data) => {
    console.log("onSelectItm", data);
    setSelectedItemLab(data);
    setLabQt(data?.item?.data?.labourqty || 0);
    setLabAmt(data?.item?.data?.labourprice || 0);
    setLabDesc(data?.item?.data?.labourdesc || "");

    // if (data?.item?.data?.state) {
    // utils.getCliamStatusDD({
    //   setClaimStatusDD,
    //   defaultVal: data?.item?.data?.state,
    // });
    // }
  };

  useEffect(() => {
    if (r1 < 3) {
      setR1(r1 + 1);
      return;
    }

    let v = 0;
    console.log("vvv", { partstotal, labourtotal, settingvat });

    if (payvat && settingvat > 0) {
      v = v + parseFloat(partstotal || 0);
      v = v + parseFloat(labourtotal || 0);
      v = v * parseFloat(settingvat || 0);
      v = v / 100;
      v = parseFloat(v || 0).toFixed(2);
      v = parseFloat(v || 0);
    }

    setClaimvatamt(v);

    // setAdjustedclaim(v2);

    const claimttl = parseFloat(
      (
        parseFloat(partstotal || 0) +
        parseFloat(labourtotal || 0) +
        parseFloat(v || 0)
      ).toFixed(2)
    );

    setClaimtotal(claimttl);

    console.log("vvv", { partstotal, labourtotal, vatAmt: v, claimttl });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [partstotal, labourtotal, settingvat, payvat]);

  useEffect(() => {
    let res = 0;
    if (partlist && partlist[0] && partlist.forEach) {
      partlist.forEach((a) => {
        let v = parseFloat(a?.data?.amt || 0);
        v *= parseFloat(a?.data?.qty || 0);
        res += v;
        // res += parseInt(a?.amt || 0, 10);
      });
    }
    res = res.toFixed(2);
    res = parseFloat(res);
    setSelectedItemPl();
    setPartstotal(res);
  }, [partlist]);

  useEffect(() => {
    let res = 0;
    if (lablist && lablist[0] && lablist.forEach) {
      lablist.forEach((a) => {
        let v = parseFloat(a?.data?.amt || 0);
        v *= parseFloat(a?.data?.labourqty || 0);
        res += v;
        // res += parseInt(a?.amt || 0, 10);
      });
    }
    res = res.toFixed(2);
    res = parseFloat(res);
    setSelectedItemLab();
    setLabourtotal(res);
  }, [lablist]);

  useEffect(() => {
    console.log("useEffect itemData", itemData);
    setClaimnumber(itemData?.claimnumber || "");

    // onSelectItmPl({
    //   itemData?.partlist || []);
    // })

    if (itemData?.claimsparts_data && itemData?.claimsparts_data[0]?.partid) {
      const claimsparts_data = itemData.claimsparts_data.map((a) => ({
        id: a?.partid,
        // key: `Lablist-${partlist?.length}`,
        number: a?.partnumber || "",
        qt: a?.qty,
        amt: utils.formatAmountForTb(a?.partprice || 0),
        desc: a?.partdesc,
        data: {
          id: a?.partid,
          amt: a?.partprice,
          newclaimnum: 0,

          // qty: partQt,
          // desc: partDesc,

          // partid: partnum,
          // partnumber: partnum,
          // qty: partQt,
          // partprice: partAmt,
          // claimid: 0,
          // claimnumber: "",
          // partdesc: partDesc,

          ...a,
        },
      }));
      setPartList(claimsparts_data);
    }

    setPartNum(itemData?.partnum || "");
    setPartQt(itemData?.partQt || "");
    setPartAmt(itemData?.partAmt || "");
    setpartDesc(itemData?.partDesc || "");

    if (
      itemData?.claimslabour_data &&
      itemData?.claimslabour_data[0]?.labourid
    ) {
      const claimslabour_data = itemData?.claimslabour_data.map((a) => ({
        id: a?.labourid,
        // key: `Lablist-${partlist?.length}`,
        // number: a?.labourid,
        qt: a?.labourqty,
        amt: utils.formatAmountForTb(a?.labourprice || 0),
        desc: a?.labourdesc,
        data: {
          id: a?.labourid,
          amt: a?.labourprice,
          newclaimnum: 0,
          ...a,
        },
      }));
      setLabList(claimslabour_data);
    }
    // onSelectItmLab(itemData?.lablist);
    // setLabQt(itemData?.labQt);
    // setLabAmt(itemData?.labAmt);
    // setLabDesc(itemData?.labDesc);
    setPartstotal(itemData?.partstotal || 0);
    setLabourtotal(itemData?.labourtotal || 0);

    setPayvat(itemData?.payvat ? true : false);
    // setPayvat(itemData?.payvat === false ? false : true);
    setClaimvatamt(itemData?.claimvatamt || 0);
    setClaimtotal(itemData?.claimtotal || 0);
    setAdjustedclaim(itemData?.adjustedclaim || 0);
    setCalculatedtotal2(itemData?.calculatedtotal || 0);

    // if (itemData?.state) {
    //   utils.getCliamStatusDD({
    //     setClaimStatusDD,
    //     defaultVal: itemData.state,
    //   });
    // }

    utils.getCliamStatusDD({
      onChangeClaimStDD,
      // setClaimStatusDD,
      defaultVal: itemData?.state,
    });

    getVat();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Flex flex={1} overflow={"hidden"} direction={"column"} p={"2rem"}>
      <Header
        label={`Claim${claimnumber ? " - " + claimnumber : ""}`}
        isLoading={isLoading}
      />
      <Layout>
        <SimpleGrid
          columns={ismobile ? 1 : 2}
          columnGap="1rem"
          rowGap="1rem"
          // mt="5"
        >
          <Flex direction={"column"} gap={"0.5rem"}>
            <Text fontWeight={"bold"} textStyle={fs}>
              Part
            </Text>
            <TableList
              headers={headers}
              items={partlist}
              type={"simple"}
              h={"10rem"}
              selectedItem={selectedItemPl}
              onSelect={onSelectItmPl}
            />
            <SimpleGrid
              columns={ismobile ? 1 : 2}
              columnGap="1rem"
              rowGap="1rem"
              mt="0.8rem"
            >
              <InputComp
                label={"Number"}
                // type={"number"}
                value={partnum}
                onChange={setPartNum}
              />
              <InputComp
                label={"Qty"}
                type={"number-f2"}
                value={partQt}
                onChange={setPartQt}
              />
              <InputComp
                label={"Price"}
                type={"number-f2"}
                value={partAmt}
                onChange={setPartAmt}
              />
              <Flex />

              {/* <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Number</Field.Label>
                <Input type="text" flex="1" textStyle={fs} />
              </Field.Root> */}
              {/* <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Qty</Field.Label>
                <Input type="date" flex="1" textStyle={fs} />
              </Field.Root> */}
              {/* <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Price</Field.Label>
                <Input type="text" flex="1" textStyle={fs} />
              </Field.Root> */}
              {/* <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Part Description</Field.Label>
                <Input type="text" flex="1" textStyle={fs} />
              </Field.Root> */}
            </SimpleGrid>

            <SimpleGrid columns={1} mt="0.8rem">
              <InputComp
                // type={"textarea"}
                label={"Part Description"}
                value={partDesc}
                onChange={setpartDesc}
                keyname={"w-100"}
              />
            </SimpleGrid>
            <Flex
              wrap={"wrap"}
              // columns={ismobile ? 1 : 3}
              columnGap="0.5rem"
              rowGap="0.5rem"
              // mt="5"
              mt="1rem"
            >
              <ButtonComp
                w={width1}
                onClick={() => onAddPart()}
                // variant={"outline"}
                // textStyle={"sm"}
                keyname={"newpart"}
                label="Add"
              />
              {/* New Part */}
              {/* </Button> */}
              <ButtonComp
                w={width1}
                onClick={() => onDelPart()}
                keyname={"delete"}
                label="Delete"
                // variant={"outline"}
                // textStyle={"sm"}
              />
              {/* Delete */}
              {/* </Button> */}
              <ButtonComp
                w={width1}
                onClick={() => onSavePart()}
                // textStyle={"sm"}
                // bg={"text"}
                disabled={!selectedItemPl}
                label={"Save"}
                keyname="save"
              />
              {/* Save */}
              {/* </Button> */}
            </Flex>
          </Flex>
          {/* <Separator w={"100%"} size={"md"} colorPalette={"fontdark"} /> */}

          <Flex direction={"column"} gap={"0.5rem"}>
            <Text fontWeight={"bold"} textStyle={fs}>
              Labour
            </Text>
            <TableList
              headers={headersLab}
              items={lablist}
              type={"simple"}
              h={"10rem"}
              selectedItem={selectedItemLab}
              onSelect={onSelectItmLab}
            />
            <SimpleGrid
              columns={ismobile ? 1 : 2}
              columnGap="1rem"
              rowGap="1rem"
              mt="0.8rem"
            >
              <InputComp
                type={"number-f2"}
                label={"Qty"}
                value={labQt}
                onChange={setLabQt}
              />
              <Flex />
              <InputComp
                type={"number-f2"}
                label={"Price"}
                value={labAmt}
                onChange={setLabAmt}
              />

              {/* <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Qty</Field.Label>
                <Input type="date" flex="1" textStyle={fs} />
              </Field.Root>
              <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Price</Field.Label>
                <Input type="text" flex="1" textStyle={fs} />
              </Field.Root>
              <Field.Root orientation="horizontal" gap={4}>
                <Field.Label textStyle={fs}>Labour Description</Field.Label>
                <Input type="text" flex="1" textStyle={fs} />
              </Field.Root> */}
            </SimpleGrid>
            <SimpleGrid columns={1} columnGap="1rem" rowGap="1rem" mt="0.8rem">
              <InputComp
                // type={"textarea"}
                label={"Part Description"}
                value={labDesc}
                onChange={setLabDesc}
                keyname={"w-100"}
              />
            </SimpleGrid>
            <Flex
              wrap={"wrap"}
              // columns={ismobile ? 1 : 3}
              columnGap="0.5rem"
              rowGap="0.5rem"
              mt="1rem"
            >
              <ButtonComp
                w={width1}
                onClick={() => onAddLab()}
                // variant={"outline"}
                // textStyle={"sm"}
                label="Add"
                keyname={"newpart"}
              />
              {/* New Part */}
              {/* </Button> */}
              <ButtonComp
                w={width1}
                onClick={() => onDelLab()}
                // variant={"outline"}
                // textStyle={"sm"}
                label="Delete"
                keyname={"delete"}
              />
              {/* Delete */}
              {/* </Button> */}
              <ButtonComp
                w={width1}
                onClick={() => onSaveLab()}
                // textStyle={"sm"}
                // bg={"text"}
                disabled={!selectedItemLab}
                label={"Save"}
                keyname="save"
              />
              {/* Save */}
              {/* </Button> */}
            </Flex>
          </Flex>
        </SimpleGrid>
        <Separator
          my={"1rem"}
          w={"100%"}
          size={"md"}
          colorPalette={"fontdark"}
        />

        <SimpleGrid
          // wrap={"wrap"}
          columns={ismobile ? 1 : 2}
          columnGap="1rem"
          rowGap="1rem"
          // mt="1rem"
        >
          <InputComp
            label={"Parts Total"}
            type={"number-f2"}
            value={partstotal}
            onChange={setPartstotal}
            keyname={"w-100"}
          />
          <InputComp
            label={"Labour Total"}
            type={"number-f2"}
            value={labourtotal}
            onChange={setLabourtotal}
            keyname={"w-100"}
          />
          <ToggleSwitch label={"VAT"} value={payvat} onChange={onChangeSwVat} />
          <InputComp
            label={"VAT Amount"}
            type={"number-f2"}
            value={payvat ? claimvatamt : ""}
            onChange={setClaimvatamt}
            disabled={!payvat}
            keyname={"w-100"}
          />
          <InputComp
            label={"Claim Total"}
            type={"number-f2"}
            value={claimtotal}
            onChange={setClaimtotal}
            keyname={"w-100"}
          />
          <InputComp
            label={"AU Parts Total"}
            type={"number-f2"}
            value={adjustedclaim}
            onChange={setAdjustedclaim}
            keyname={"w-100"}
          />
          <InputComp
            label={"Invoiced Total"}
            type={"number-f2"}
            value={calculatedtotal2 || claimtotal}
            onChange={setCalculatedtotal2}
            keyname={"w-100"}
          />
          <InputComp
            label={"Status of Claim"}
            type={"dropdown"}
            items={claimStatusDD}
            onChange={onChangeClaimStDD}
            placeholder={"Change State"}
            // disabled={!selectedItem}
            // keyname={"claim-state"}
            required={true}
            keyname={"w-100"}
          />

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Parts Total</Field.Label>
            <Input
              type="text"
              value={partstotal}
              onChange={(e) => setPartstotal(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Labour Total</Field.Label>
            <Input
              type="text"
              value={labourtotal}
              onChange={(e) => setLabourtotal(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
          {/* <ToggleSwitch label={"VAT"} value={payvat} onChange={setPayvat} /> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>VAT Amount</Field.Label>
            <Input
              value={claimvatamt}
              onChange={(e) => setClaimvatamt(e.target.value)}
              type="text"
              flex="1"
              textStyle={fs}
            />
          </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Claim Total</Field.Label>
            <Input
              type="text"
              value={claimtotal}
              onChange={(e) => setClaimtotal(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>AU Parts Total</Field.Label>
            <Input
              type="text"
              value={adjustedclaim}
              onChange={(e) => setAdjustedclaim(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}

          {/* <Field.Root orientation="horizontal" gap={4}>
            <Field.Label textStyle={fs}>Invoiced Total</Field.Label>
            <Input
              type="text"
              value={calculatedtotal}
              onChange={(e) => setCalculatedtotal(e.target.value)}
              textStyle={"md"}
            />
          </Field.Root> */}
        </SimpleGrid>
        <Flex h={"100%"} />
      </Layout>
      <SimpleGrid
        columns={1}
        columnGap="1rem"
        rowGap="1rem"
        justifyItems={"flex-end"}
        mt="1rem"
      >
        <Flex gap={"1rem"}>
          <ButtonComp label="Previous" onClick={onPrev} keyname={"prev"} />
          <ButtonComp
            label="Save"
            onClick={onSave}
            keyname={"save"}
            disabled={isLoading}
          />
        </Flex>
      </SimpleGrid>
    </Flex>
  );
};

export default ClaimViewStepParts;
